/* global $ */
/* eslint no-extend-native: 0 no-bitwise: 0 */

/* tiny additions to jQuery */

$.$body = $('body').addClass('js-active'); // caches the $('body') element to save repeat calls to $('body')

if (!Array.prototype.forEach) {
  Array.prototype.forEach = function(callback /* , thisArg */) {
    let k;
    if (this === null) {
      throw new TypeError('this is null or not defined');
    }
    const O = Object(this);
    const len = O.length >>> 0;
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }
    k = 0;
    while (k < len) {
      let kValue;
      if (k in O) {
        kValue = O[k];
        callback.call(undefined, kValue, k, O);
      }
      k++;
    }
  };
}

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

if (!Array.prototype.from) {
  Array.from =
    Array.from ||
    function(object) {
      return [].slice.call(object);
    };
}
